import React from "react";
import useWindowSize from "../../../../hooks/useWindowSize";
//test deployment
const GroupTable = ({ data = [], isWhitelistCity = false }) => {
  const { size } = useWindowSize();
  const isMobileView = (size?.width || 0) <= 768;
  const mobileTitle = [
    "Pos",
    "Nama Sekolah",
    "P",
    "W",
    "D",
    "L",
    "F",
    "A",
    "GD",
    !isWhitelistCity ? "PS*" : "OC",
    "P",
  ];
  const webTitle = [
    "Pos",
    "Nama Sekolah",
    "Played",
    "Won",
    "Drawn",
    "Lost",
    "For",
    "Against",
    "Goal Difference",
    !isWhitelistCity ? "PS*" : "OC Points",
    "Points",
  ];
  const titleTable = isMobileView ? mobileTitle : webTitle;
  return data?.map((val, index) => {
    const isCompleteMatch = val?.classments?.every((match) => match?.play >= 2);
    return (
      <div
        key={index}
        className="mx-auto bg-white !rounded-lg shadow-md overflow-hidden mb-8 border-[3px] border-solid border-[#F0F2F9]"
      >
        <div
          className="overflow-x-auto"
          style={{
            WebkitOverflowScrolling: "touch", // Enable momentum scrolling on iOS
            scrollbarWidth: "thin", // Firefox
            scrollbarColor: "#CBD5E1 transparent", // Firefox
            msOverflowStyle: "-ms-autohiding-scrollbar", // IE/Edge
            cursor: "grab", // Show grab cursor to indicate scrollable
          }}
          onMouseDown={(e) => (e.currentTarget.style.cursor = "grabbing")}
          onMouseUp={(e) => (e.currentTarget.style.cursor = "grab")}
          onMouseLeave={(e) => (e.currentTarget.style.cursor = "grab")}
        >
          <table className="w-full text-left mb-2">
            <thead>
              <tr className="bg-[#006E8D] text-white">
                <th className="py-[10px] pl-3 text-[18px] w-[43px] whitespace-nowrap px-2 md:px-0">
                  {titleTable[0]}
                </th>
                <th className="py-[10px] w-[250px] text-[18px] whitespace-nowrap px-2 md:px-0">
                  {titleTable[1]}
                </th>
                <th className="py-[10px] w-[86px] text-[18px] text-center whitespace-nowrap px-2 md:px-0">
                  {titleTable[2]}
                </th>
                <th className="py-[10px] text-[18px] w-[86px] text-center whitespace-nowrap px-2 md:px-0">
                  {titleTable[3]}
                </th>
                <th className="py-[10px] text-[18px] w-[86px] text-center whitespace-nowrap px-2 md:px-0">
                  {titleTable[4]}
                </th>
                <th className="py-[10px] text-[18px] w-[86px] text-center whitespace-nowrap px-2 md:px-0">
                  {titleTable[5]}
                </th>
                <th className="py-[10px] text-[18px] w-[86px] text-center whitespace-nowrap px-2 md:px-0">
                  {titleTable[6]}
                </th>
                <th className="py-[10px] text-[18px] w-[86px] text-center whitespace-nowrap px-2 md:px-0">
                  {titleTable[7]}
                </th>
                <th className="py-[10px] text-[18px] w-[200px] text-center whitespace-nowrap px-2 md:px-0">
                  {titleTable[8]}
                </th>
                <th className="py-[10px] text-[18px] w-[86px] text-center whitespace-nowrap px-2 md:px-0">
                  {titleTable[9]}
                </th>
                <th className="py-[10px] text-[18px] w-[86px] whitespace-nowrap px-2 md:px-0">
                  {titleTable[10]}
                </th>
              </tr>
            </thead>
            <tbody>
              {val?.classments
                ?.map((classment) => {
                  return {
                    pos: classment?.position,
                    name: classment?.club_name,
                    p: classment?.play,
                    w: classment?.win,
                    d: classment?.draw,
                    l: classment?.lose,
                    gf: classment?.gf,
                    ga: classment?.ga,
                    gd: classment?.gd,
                    pn: classment?.point,
                    supporter_point: classment?.["supporter_point"],
                    form:
                      classment?.forms?.length === 0
                        ? ["", ""]
                        : classment?.forms?.length === 1
                        ? [...classment?.forms, ""]
                        : classment?.forms,
                    // form: classment?.forms ?? [''],
                  };
                })
                .map((team, index) => (
                  <tr
                    key={index}
                    style={{
                      background:
                        isCompleteMatch && index < 4
                          ? "linear-gradient(0deg, rgba(255, 255, 255, 0.60) 0%, rgba(255, 255, 255, 0.60) 100%), #97D064"
                          : "",
                    }}
                    className={`border-t-2 border-solid border-[#F0F2F9]`}
                  >
                    <td className="px-2 md:px-0 py-2 w-[43px] text-[14px] whitespace-nowrap text-center md:text-left">
                      {team.pos}
                    </td>
                    <td className="py-2 text-[14px] w-[250px] font-semibold whitespace-nowrap px-2 md:px-0">
                      {team.name}
                    </td>
                    <td className="py-2 text-[14px] w-[86px] text-center whitespace-nowrap px-2 md:px-0">
                      {team.p}
                    </td>
                    <td className="py-2 text-[14px] text-center whitespace-nowrap px-2 md:px-0">
                      {team.w}
                    </td>
                    <td className="py-2 text-[14px] text-center whitespace-nowrap px-2 md:px-0">
                      {team.d}
                    </td>
                    <td className="py-2 text-[14px] text-center whitespace-nowrap px-2 md:px-0">
                      {team.l}
                    </td>
                    <td className="py-2 text-[14px] text-center whitespace-nowrap px-2 md:px-0">
                      {team.gf}
                    </td>
                    <td className="py-2 text-[14px] text-center whitespace-nowrap px-2 md:px-0">
                      {team.ga}
                    </td>
                    <td className="py-2 text-[14px] text-center whitespace-nowrap px-2 md:px-0">
                      {team.gd}
                    </td>
                    <td className="py-2 text-[14px] text-center whitespace-nowrap px-2 md:px-0">
                      {team?.["supporter_point"]}
                    </td>
                    <td className="py-2 text-[14px] text-center whitespace-nowrap px-2 md:px-0">
                      {team.pn}
                    </td>
                    {/* <td className="py-2 text-[14px] text-center whitespace-nowrap px-2 md:px-0">
                      <div className="flex space-x-2">
                        {team?.form.map((result, i) => (
                          <div key={i}>
                            {result !== "" ? (
                              <span
                                className={`rounded-full text-center font-semibold text-[14px] w-[20px] h-[20px] flex justify-center items-start text-white ${
                                  result === "W"
                                    ? "bg-[#53C368]"
                                    : result === "D"
                                    ? "bg-[#FFBC00]"
                                    : "bg-[#F1000D]"
                                }`}
                              >
                                {result}
                              </span>
                            ) : (
                              <span
                                className={`rounded-full text-center font-semibold text-[14px] w-[20px] h-[20px] flex justify-center items-start text-white
                            bg-[#B8C1CB] 
                            `}
                              >
                                {result}
                              </span>
                            )}
                            {i &&
                            i + 1 === team?.form?.length &&
                            team?.form?.[i] !== "" ? (
                              <div
                                className={`w-[20px] mt-1 border-b-[3.2px] border-t-0 border-l-0 border-r-0 border-solid ${
                                  result === "W"
                                    ? "border-[#53C368]"
                                    : result === "D"
                                    ? "border-[#FFBC00]"
                                    : "border-[#F1000D]"
                                }`}
                              />
                            ) : null}
                          </div>
                        ))}
                      </div>
                    </td> */}
                  </tr>
                ))}
            </tbody>
          </table>
        </div>
      </div>
    );
  });
};

export default GroupTable;
